<template>
  <div class="qualification-index">
    <header>
      <div class="mainTop">
        <img class="banner" src="../assets/img/资质中心_banner.png" />
        <div class="title">资质中心</div>
        <div class="left"></div>

        <div class="right"></div>
      </div>
    </header>

    <main>
      <div class="main2">
        <div class="left"></div>
        <div class="center contentWrapper">
          <!-- 左侧 -->
          <div class="center-left">
            <ul class="zizhizhongxin-left">
              <li
                class="change"
                :class="currentIndex == index ? 'active' : ''"
                v-for="(item, index) in list"
                :key="item.id"
                @click="change(index)"
              >
                <router-link :to="{ path: `${item.gopath}` }" class="color">{{
                  item.title
                }}</router-link>
              </li>
            </ul>
          </div>
          <!-- 右侧 -->
          <router-view
            ref="Mychild"
            class="transformScale"
            v-cloak
          ></router-view>
        </div>
        <!-- <div class="right"></div> -->
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "./footer.vue";
export default {
  components: { Footer },
  name: "qualification",
  data() {
    return {
      currentIndex: 0, //表示当前选项卡,
      list: [
        // {
        //   id: 1, //用来代表每一个对象
        //   title: "行业协会", //标题
        //   gopath: "/qualification/industry"
        // },
        {
          id: 2,
          title: "资质", //标题
          gopath: "/qualification/engineering"
        },
        {
          id: 3,
          title: "荣誉", //标题
          gopath: "/qualification/honor"
        },
        {
          id: 4,
          title: "其他", //标题
          gopath: "/qualification/other"
        }
      ]
    };
  },
  mounted() {
    // 绑定滚动事件监听器
    window.addEventListener("keyup", this.closeDialog);
  },
  beforeDestroy() {
    // 组件销毁时移除滚动事件监听器
    window.removeEventListener("keyup", this.closeDialog);
  },
  methods: {
    change(index) {
      console.log(index);
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index;
    },
    closeDialog(event) {
      // console.log(event.key);
      if (event.key == "Enter") {
        console.log("enter");
        this.$refs.Mychild.closeDialog();
      }
    }
  }
};
</script>
<style scoped>
header {
  height: 406px;
}

header h1 {
  margin-top: 163px;
  text-align: center;
  font-size: 48px;
  color: #ffffff;
  line-height: 65px;
  letter-spacing: 12px;
}
main {
  margin-bottom: 99.9936px;
}
main .center {
  margin-top: 73.9968px;
  /* background-color: green; */
  display: flex;
}
.main2 {
  position: relative;
  min-height: 639px;
  display: flex;
  justify-content: center;
}
.main2 .center {
  /* position: absolute; */
  /* width: 1168px; */
  width: 1460px;
  margin: 0 auto;
  /* left: 50%; */
  /* margin-left: -630px; */
  margin-top: 160px;
}
.center-left {
  margin-right: 65px;
  float: left;
}
.center-left ul {
  margin-top: 6px;
  width: 65px;
}
.center-left ul li {
  margin-bottom: 13px;
}
.center-left ul .active a {
  color: #140047;
  font-weight: 700;
}
.center-left ul li a {
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.22);
  line-height: 21px;
  transition: color 0.3s;
}

.center-left ul li a:hover {
  color: #140047;
  font-weight: 700;
}
.center-right h1 {
  margin-bottom: 41px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.center-right .center-nav .color {
  color: #140047;
}
.center-right .center-nav .bgc {
  background-color: #140047;
}
.center-right p {
  margin-bottom: 40px;
  font-size: 20px;
  font-weight: 400;
  color: #01021b;
  line-height: 36px;
  letter-spacing: 0.96px;
}
.center-right .center-nav {
  margin-bottom: 32px;
  display: flex;
  position: relative;
}
.center-right .center-nav a {
  height: 48px;
  margin-right: 54px;
  font-size: 20px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.3);
  line-height: 28px;
  letter-spacing: 0.96px;
  transition: color 0.3s;
}
.center-right .center-nav span i {
  display: block;
  margin-top: 16px;
  width: 100%;
  height: 4px;
  background: transparent;
}
.center-right .center-nav span:nth-child(3) {
  position: absolute;
  top: 44px;
  width: 100%;
  height: 4px;
  background-color: rgba(239, 239, 242, 0.5);
  z-index: -1;
}
.center-right .center-nav a:hover {
  color: #140047;
  font-weight: 500;
}
.center-right .center-nav a:hover i {
  background-color: #140047;
  font-weight: 500;
}
.center-right ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.center-right ul li {
  width: 22%;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
}
.center-right ul li .img {
  position: relative;
  height: 240px;
  background-color: #f1f4fb;
}
.center-right ul li .img div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 259px;
  height: 200px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb1e3385714d495265e36107819116615bec83da19c9fd80f8deaf488b55a6306) -0.0521rem -0.0469rem
    no-repeat;
}
.center-right ul li .text {
  padding: 20px 52px 20px 20px;
  height: 112px;
  background-color: rgba(255, 255, 255, 0.88);
  font-size: 18px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.58);
  line-height: 36px;
  letter-spacing: 0.96px;
}
.mainTop {
  /* height: 406px; */
  height: 500px;
  position: relative;
}
.title {
  position: absolute;
  width: 178px;
  height: 49px;
  margin: 0 auto;
  /* top: 188px; */
  top: 222px;
  font-size: 36px;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 49px;
  letter-spacing: 9px;
  white-space: nowrap;
}
.zizhizhongxin-left {
  position: sticky;
  top: 100px;
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/qualification.vue